module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "n.i.b.s."
    }
  }, [_c('h2', [_vm._v("N.I.B.S.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "4%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("F=Frank J=Jackie")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("Jackie, what is going on?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Nothing, Frank.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("The wife?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Okay.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("Kids?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Yep.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("The car?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("AAH.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Frank, yourself?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("I don’t feel like saying anything. Your talking is too much and I need an aspirin.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Buffered?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("Yep.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("How many?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("Two.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("J:")]), _vm._v(" "), _c('td', [_vm._v("Later.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("F:")]), _vm._v(" "), _c('td', [_vm._v("Yeah, later.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6db54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0005.vue
// module id = 84
// module chunks = 0